// app/question/test.js

(function () {
    "use strict";
    var controllerId = "test";
    angular.module("app").controller(controllerId, ["$rootScope", "$scope", "$filter", "$location", "common", "bootstrap.dialog", "$routeParams", "$q", "$uibModal", "datacontext", "sectionMenu", "filterFilter", "$translate", test]);

    function test($rootScope, $scope, $filter, $location, common, bDialog, $routeParams, $q, $uibModal, datacontext, sectionMenu, filterFilter, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, "logError");
        var logSuccess = getLogFn(controllerId, "logSuccess");
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard
        var vm = this;
        vm.title = "Test";
        vm.view = "list";       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "test"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = !$rootScope.licenzaValida;
        vm.exportDisabled = false;
        vm.addTitle = 'NuovoTest';

        //Workflow creazione test
        vm.inviaPerVerifica = false;
        vm.accetta = false;
        vm.rifiuta = false;
        vm.modifica = false;
        vm.readonly = true;

        vm.sendForVerify = sendForVerify;
        vm.accept = accept;
        vm.reject = reject;
        vm.modify = modify;

        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.isStudente = $rootScope.isAuthorized("STUDENTE");
        vm.currentLanguage = $translate.use() || $translate.proposedLanguage();

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ["Difficolta'", "Materia", "Titolo", "Ultima Modifica"];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[3];
        if ($rootScope.isAuthorized("STUDENTE")) {
            vm.list.ordine = ["Difficolta'", "Docente", "Materia", "Titolo", "Ultima Modifica"];
            vm.list.ordine = common.setOrdine(vm.list.ordine);
            vm.ordine = vm.list.ordine[4];
        }
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            cerca();
        };

        //Elenchi dettaglio
        vm.list.questions = [];
        vm.getRecord = getRecord;
        vm.getListQuestions = getListQuestions;

        //Filtro
        vm.filter = {};
        vm.filter.testo = "";
        vm.filter.stato = 0;
        vm.fTesto = "";
        vm.fStato = 0;
        vm.fTipologia = 0;
        vm.filter.tipologia = 0;
        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.anno = vm.fAnno;

        //Elenco per finestra modale di Create
        vm.materie = [];
        vm.tipoTest = [];

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.importQuestion = importQuestion;
        vm.deleteQuestion = deleteQuestion;
        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;
        vm.rifiutoPopup = rifiutoPopup;
        vm.createSession = createSession;
        vm.community = community;
        vm.istitutoShare = istitutoShare;
        vm.getSchedaCompetenze = getSchedaCompetenze;        
        vm.modalDetailAC = modalDetailAC;
        vm.setDidatticaAttivo = setDidatticaAttivo;
        vm.setCompBaseAttivo = setCompBaseAttivo;
        vm.stampaTest = stampaTest;

        vm.selezionaDeselezioneTutto = selezionaDeselezioneTutto;
        
        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getMaterie(), getTipoTest()];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.testId != null) {
                            setView("detail");
                            getRecord($routeParams.testId, 0);
                        }
                    });


            if ($rootScope.mdTest != undefined && $rootScope.mdTest == true) {
                if (vm.currentLanguage == 'it') {
                    $uibModal.open({
                        backdrop: 'static',
                        keyboard: false,
                        templateUrl: '/app/EDUP_Test/modal/avvisoMedCapture.html?version=43',
                        controller: 'avvisoMedCapture',
                        windowClass: 'welcomeBody medcapture'
                    });
                } else {
                    $uibModal.open({
                        backdrop: 'static',
                        keyboard: false,
                        templateUrl: '/app/EDUP_Test/modal/avvisoMedCapture.html?version=43',
                        controller: 'avvisoMedCapture',
                        windowClass: 'welcomeBody medcapture welcome-en'
                    });
                }
                
            }
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            if (view == 'list') {
                cerca();
            }
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.testo = vm.fTesto == null ? 0 : vm.fTesto;
            vm.filter.tipologia = vm.fTipologia == null ? 0 : vm.fTipologia;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.testDocentiAllievi_countByFilter(vm.filter.stato, vm.filter.testo, 0, vm.isStudente == true ? 1 : 0, vm.filter.tipologia)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;
            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;
            vm.loading = true;
            return datacontext.testDocentiAllievi_getAllByFilter(vm.pageSize, vm.page, vm.filter.stato, vm.filter.testo, 0, vm.isStudente == true ? 1 : 0, vm.filter.tipologia, vm.ordine.value)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.test_get(id).then(function (data) {
                //console.info("vm.record", data);
                vm.index = index;
                vm.record = data;
                vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                vm.record.status = $filter("teststatus")(data.status);                

                vm.newWord = '';

                $scope.searchItems = [];
                //Sort Array
                $scope.searchItems.sort();
                //Define Suggestions List
                $scope.suggestions = [];
                $scope.suggestionsObj = [];
                //Define Selected Suggestion Item
                $scope.selectedIndex = -1;
                $scope.indexLastComma = 0;

                //Azzera liste
                vm.list.questions = [];
                vm.newWord = '';
                if (!vm.isStudente) {           //Se � docente
                    getSchedaCompetenze().then(function (data) {                        
                        getListQuestions(id);
                        gestisciBottoni();
                        setView('detail');
                    });
                }
                else {
                    getListQuestions(id);
                    gestisciBottoni();
                    setView("detail");
                }
            });
        }

        function addRecord(id) {
            return datacontext.test_get(id).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    vm.records.push(data);
                    vm.countRecords++;
                }
                else
                    logError($translate.instant('ErroreCreazione'));
            });
        }

        function updateItem() {
            if (vm.record.tipoTestId == null)
                vm.record.tipoTestId = 0;

            return datacontext.test_update(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('DatoSalvato'));
                    vm.newWord = '';
                    vm.record.tags = data.tags;
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        //Workflow
        function gestisciBottoni() {
            //Gestione bottoni interfaccia
            vm.inviaPerVerifica = false;
            vm.accetta = false;
            vm.rifiuta = false;
            vm.modifica = false;
            vm.readonly = true;
            vm.rifiuto = false;

            if ($rootScope.isAuthorized("STUDENTE")) {
                if (vm.record.statusCode == 1) {
                    vm.readonly = false;
                    vm.inviaPerVerifica = true;
                }
                else if (vm.record.statusCode == 4) {
                    vm.modifica = true;
                    vm.rifiuto = true;
                }
            }
            else if ($rootScope.isAuthorized("DOCENTE")) {

                if (!vm.record.studenteId || vm.record.studenteId == 0 || vm.record.studenteId == null || vm.record.statusCode == 3) {
                    vm.readonly = false;
                }
                if (vm.record.statusCode == 2) {
                    vm.accetta = true;
                    vm.rifiuta = true;
                }
                if (vm.record.statusCode == 4) {
                    vm.rifiuto = true;
                }
            }
        }

        function sendForVerify() {
            return datacontext.test_sendForVerify(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('TestInVerifica'));
                    vm.record.statusCode = data.statusCode;
                    vm.record.status = $filter("teststatus")(data.status);
                    vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                    gestisciBottoni();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function accept() {
            return datacontext.test_accept(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('TestAccettato'));
                    vm.record.statusCode = data.statusCode;
                    vm.record.status = $filter("teststatus")(data.status);
                    vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                    gestisciBottoni();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function reject() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/rifiutoPopup.html?version=43",
                controller: "rifiutoPopup",
                resolve: {
                    test: function () {
                        return vm.record;
                    },
                    readOnly: function () {
                        return "false";
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                return datacontext.test_reject(returnItem).then(function (data) {
                    if (data && data != null && data.Id > 0) {
                        logSuccess($translate.instant('TestRifiutato'));
                        vm.record.statusCode = data.statusCode;
                        vm.record.status = $filter("teststatus")(data.status);
                        vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                        gestisciBottoni();
                    }
                    else
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            });
        }

        function modify() {
            return datacontext.test_modify(vm.record).then(function (data) {
                if (data && data != null && data.Id > 0) {
                    logSuccess($translate.instant('PossibileModificareTest'));
                    vm.record.statusCode = data.statusCode;
                    vm.record.status = $filter("teststatus")(data.status);
                    vm.record.data = $filter("date")(data.DtUpdate, "dd/MM/yyyy");
                    gestisciBottoni();
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        function deleteItem(item) {
            var msg = " Test " + item.title + " ";
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.test_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //List Methods
        function getListQuestions(id) {
            if (!id) return;
            return datacontext.questionTest_getAllByTest(id, "sequence").then(function (data) {
                if (data && !vm.isStudente) {
                    //Aggiornamento tasti seleziona tutte competenze
                    if (vm.assi) {
                        vm.assi.CompetenzeChiave.forEach(function (cChiave) {
                            cChiave.CompetenzeBase.forEach(function (cBase) {
                                cBase.qAttivo = true;    //tasto acceso
                                var BreakException = {};
                                try {
                                    data.forEach(function (q) {
                                        if (q.CompetenzeBase) {
                                            var check = _.find(q.CompetenzeBase, function (o) {
                                                return o.CompBaseId == cBase.Id && o.Attivo == false;
                                            });                                            
                                            if (check != undefined) {
                                                cBase.qAttivo = false;   //tasto spento
                                                throw BreakException;
                                            }
                                        }
                                    });
                                }
                                catch (e) {
                                    if (e !== BreakException) throw e;
                                }
                            });
                        });
                    }
                    return vm.list.questions = data;
                }                
            });
        }


        //Elenchi Parametri
        function getMaterie() {
            if ($rootScope.isAuthorized("STUDENTE")) {
                return datacontext.materia_getAllListByDocente(vm.record.docenteId).then(function (data) {
                    return vm.materie = data;
                });
            }
            else {
                return datacontext.materia_getAllList().then(function (data) {
                    return vm.materie = data;
                });
            }
        }

        function getTipoTest() {
            return datacontext.tipoTest_getAllList().then(function (data) {
                return vm.tipoTest = data;
            });
        }

        //Metodi di delete object List
        function deleteQuestion(item) {
            var title = (item.questionTitle != null) ? item.questionTitle : item.questionImgName;
            var msg = " " + $translate.instant('Domanda') + ": " + title;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.questionTest_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('ErroreRimozione'));

                    var index = vm.list.questions.indexOf(item);
                    var sequence = item.sequence;
                    vm.list.questions.splice(index, 1);
                    vm.list.questions.forEach(function (obj) {
                        if (obj.sequence > sequence)
                            obj.sequence = obj.sequence - 1;
                    });
                });
            });
        }

        //Metodi interfaccia 
        function changeSequence(orderList) {
            datacontext.questionTest_changeSequence(orderList).then(function (data) {
                if (data) {
                    logError($translate.instant('ImpossibileSalvareDati'));
                }                    
            });
        }

        function updateSequence() {
            if (vm.readonly == true)
                return;

            var orderList = [];
            var sequence = 1;

            vm.list.questions.forEach(function (item) {
                item.sequence = sequence++;
                orderList.push(item.Id);
            });

            changeSequence(orderList);
        }

        vm.sortingLog = [];

        vm.sortableOptions = {
            handle: "> .myHandle",
            update: function (e, ui) {
                var logEntry = vm.list.questions.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLog.push("Update: " + logEntry);
            },
            stop: function (e, ui) {
                // this callback has the changed model
                var logEntry = vm.list.questions.map(function (i) {
                    return i.value;
                }).join(", ");
                vm.sortingLog.push("Stop: " + logEntry);
                updateSequence();
            }
        };

        function createSession() {
            $location.path('/EDUP_session/' + vm.record.Id + '/create=true');
        }

        function community(index, value, questions) {
            if (!questions || questions < 5) {
                logError($translate.instant('AvvisoCondivisione'));
                return;
            }

            datacontext.test_setCommunity(vm.records[index].Id, value).then(function (data) {
                if (data == '200') {
                    vm.records[index].community = value;
                    if (value)
                        logSuccess($translate.instant('TestCondivisoConCommunity'));
                    else
                        logSuccess($translate.instant('TestNonCondivisoConCommunity'));
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }

        function istitutoShare(index, value, questions) {
            if (!questions || questions < 5) {
                logError($translate.instant('AvvisoCondivisione'));
                return;
            }

            datacontext.test_setIstitutoShare(vm.records[index].Id, value).then(function (data) {
                if (data == '200') {
                    vm.records[index].istitutoShare = value;
                    if (value)
                        logSuccess($translate.instant('TestCondivisoConIstituto'));
                    else
                        logSuccess($translate.instant('TestNonCondivisoConIstituto'));
                }
                else
                    logError($translate.instant('ErroreElaborazioneRichiesta'));
            });
        }        

        function getSchedaCompetenze() {
            return datacontext.schedaCompetenzeTest_getAll(vm.record.Id, vm.record.docenteId, vm.filter.anno).then(function (compTest) {
                vm.compTest = compTest;
                if (vm.compTest && vm.compTest.length > 0) {
                    return datacontext.asseCulturale_get(vm.compTest[0].AsseId).then(function (asse) {
                        asse.CompetenzeChiave.forEach(function (cChiave) {
                            cChiave.CompetenzeBase.forEach(function (cBase) {
                                var check = _.find(vm.compTest, function (o) {
                                    return o.CompBaseId == cBase.Id;
                                });
                                if (check) {
                                    cBase.Attivo = check.Attivo;
                                    cBase.Personalizzazione1 = check.Personalizzazione1;
                                    cBase.Personalizzazione2 = check.Personalizzazione2;
                                    cBase.Peso = check.Peso;
                                }
                            });
                        });
                        return vm.assi = asse;
                    });
                }
                else return null;
            });
        }        

        function setCompBaseAttivo(item) {
            item.Attivo = !item.Attivo;
            return datacontext.questionTestCompBase_update(item).then(function (data) {    
                getListQuestions(vm.record.Id);//inserito per aggiornare tasto del seleziona tutto
                if (!data || data == null || data.Id == 0)
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }


        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var docenti = [];
            var docenteId = null;

            var materie = [];
            var materiaId = null;

            if ($rootScope.isAuthorized("DOCENTE")) {
                var docente = {};
                docente.Id = $rootScope.id;
                docente.Name = $rootScope.name;
                docenti = [docente];
                docenteId = $rootScope.id;

                materie = vm.materie;
            }

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/testAdd.html?version=43",
                controller: "testAdd",
                resolve: {
                    docenti: function () {
                        return docenti;
                    },
                    docenteId: function () {
                        return docenteId;
                    },
                    materie: function () {
                        return materie;
                    },
                    materiaId: function () {
                        return materiaId;    //materiaId non impostato - da selezionare in inserimento
                    },
                    tipoTest: function () {
                        return vm.tipoTest;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('ErroreCreazione'));

                logSuccess($translate.instant('DatoSalvato'));
                return $q.when(addRecord(returnItem.Id)).then(function () {
                    vm.get(returnItem.Id, vm.countRecords - 1);
                });

            });
        }

        // Question
        function importQuestion() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/questionTestAdd.html?version=43",
                controller: "questionTestAdd",
                resolve: {
                    testId: function () {
                        return vm.record.Id;    //testId impostata con record visualizzato
                    },
                    testSourceId: function () {
                        return null;    //testSourceId impostata con record visualizzato
                    },
                    questions: function () {
                        return null;
                    },
                    questionId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                getListQuestions(vm.record.Id);
                logSuccess($translate.instant('DatoSalvato'));
            });
        }

        function rifiutoPopup() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/rifiutoPopup.html?version=43",
                controller: "rifiutoPopup",
                resolve: {
                    test: function () {
                        return vm.record;
                    },
                    readOnly: function () {
                        return "true";
                    }
                }
            });
        }        
       
        //modale visualizzazione dettaglio abilit� e conoscenze
        function modalDetailAC(item) {
            var modalDetail = {};
            angular.copy(item, modalDetail);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/didatticaCompetenze/modal/schedaCompetenzeProfiloDetail.html?version=43',
                controller: 'schedaCompetenzeProfiloDetail',
                windowClass: 'modal-wide',
                resolve: {                      // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    schedaCompetenzeDetail: function () {
                        return modalDetail;
                    }
                }
            });
            
            modalInstance.result.then(function (returnItem) {
                var sc = _.find(vm.compTest, function (o) { return o.CompBaseId == item.Id });
                if (sc && sc.Id && sc.Id > 0) {
                    sc.Personalizzazione1 = returnItem.Personalizzazione1;
                    datacontext.schedaCompetenzeTest_update(sc).then(function (data) {
                        if (data && data.Id && data.Id > 0) {
                            item.Personalizzazione1 = sc.Personalizzazione1;
                            logSuccess($translate.instant('DatoSalvato'));
                        }                            
                        else
                            logError($translate.instant('ImpossibileSalvareDati'));
                    });
                }
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });            
        }

        function stampaTest(testId) {
            if (!testId)
                testId = vm.record.Id;

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: "/app/EDUP_Test/modal/stampaTest.html?version=43",
                controller: "stampaTest",
                windowClass: 'modal-wide-print',
                resolve: {
                    testId: function () {
                        return testId;
                    }
                }
            });
        }

        function setDidatticaAttivo(item) {
            var sc = _.find(vm.compTest, function (o) { return o.CompBaseId == item.Id });
            if (sc && sc.Id && sc.Id > 0) {
                if (item.Attivo)
                    sc.Peso = 100;
                else
                    sc.Peso = 0;

                datacontext.schedaCompetenzeTest_update(sc).then(function (data) {
                    if (!data || !data.Id || data.Id == 0)
                        logError($translate.instant('ImpossibileSalvareDati'));
                });
            }
            else
                logError($translate.instant('ImpossibileSalvareDati'));
        }

        function selezionaDeselezioneTutto(item, value) {
            var msg = "";
            if (value == 1)
                msg = $translate.instant('AvvisoAttivareCompetenza') + " " + item.Codice + " - " + item.CompetenzaBase + "?";
            else
                msg = $translate.instant('AvvisoDisattivareCompetenza') + " " + item.Codice + " - " + item.CompetenzaBase + "?";

            bDialog.confirmationDialog($translate.instant('Conferma'), msg).then(function () {
                return datacontext.questionTestCompBase_updateAll(item.Id, vm.record.Id, value).then(function (data) {
                    getListQuestions(vm.record.Id);
                    logSuccess($translate.instant('DatiSalvati'));
                });
            });
        }




        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-SUGGESTION PER TAG-#-#-#-#-#-#

        //vm.record.tags = '';

        vm.newWord = '';

        $scope.searchItems = [];
        //Sort Array
        $scope.searchItems.sort();
        //Define Suggestions List
        $scope.suggestions = [];
        $scope.suggestionsObj = [];
        //Define Selected Suggestion Item
        $scope.selectedIndex = -1;
        $scope.indexLastComma = 0;

        //Function To Call On ng-change
        $scope.search = function () {
            $scope.suggestions = [];
            $scope.suggestionsObj = [];

            var myMaxSuggestionListLength = 0;

            if (!vm.newWord || vm.newWord.length == 0) //!vm.record.tags || vm.record.tags.length == 0)
                return;

            //estrapolo l'ultimo tag inserito
            /*var lastTag = '';
            $scope.indexLastComma = parseInt(vm.record.tags.lastIndexOf(','));
            setLastTag(vm.record.tags);*/

            var tags = vm.record.tags;//.substr(0, $scope.indexLastComma);
            var arrayTag = tags != null ? tags.split(',') : new Array();

            //if ($scope.lastTag == undefined) return;
            //Effettuo il replace di tutti gli spazi ma esclusivamente per il conteggio dei caratteri
            //if ($scope.lastTag.split(' ').join('').length < 3) return; //numero minimo di caratteri 

            if (vm.newWord.split(' ').join('').length < 3) return; //numero minimo di caratteri

            return datacontext.tag_getAllList(0, vm.newWord, 0).then(function (data) {
                if (data) {
                    $scope.suggestions = [];
                    //$scope.suggestionsObj = data;
                    $scope.selectedIndex = -1;
                    data.forEach(function (item) {
                        var bExists = false;
                        arrayTag.forEach(function (tag) {
                            if (tag.split(' ').join('') == item.Name.split(' ').join('') && tag.length === item.Name.length) {
                                bExists = true;
                            }

                        });
                        if (!bExists) {
                            $scope.suggestions.push(item.Name);
                            $scope.suggestionsObj.push(item);
                        }

                    });
                }
            });
        };

        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndex', function (val) {
            if (val === -1) {
                $scope.suggestions = [];
                $scope.suggestionsObj = [];
            }
        });

        //List Item Events
        //Function To Call on ng-click
        $scope.AssignValueAndHide = function (index) {
            //imposto il nuovo testo nella casella di autocomplete
            setSearchText(index);

            $scope.suggestions = [];
            $scope.suggestionsObj = [];
        };
        //======================================

        //Text Field Events
        //Function To Call on ng-keydown
        $scope.checkKeyDown = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndex
                event.preventDefault();
                if ($scope.selectedIndex + 1 < $scope.suggestions.length)
                    $scope.selectedIndex++;
                else
                    $scope.selectedIndex = $scope.suggestions.length - 1;
                //estrapolo l'ultimo tag inserito
                //setLastTag(vm.record.tags);

                //imposto il nuovo testo nella casella di autocomplete
                setSearchText($scope.selectedIndex);
            } else if (event.keyCode === 38) { //up key, decrement selectedIndex
                event.preventDefault();
                if ($scope.selectedIndex - 1 > -1)
                    $scope.selectedIndex--;
                else
                    $scope.selectedIndex = 0;
                //estrapolo l'ultimo tag inserito
                //setLastTag(vm.record.tags);

                //imposto il nuovo testo nella casella di autocomplete
                setSearchText($scope.selectedIndex);
            }
            else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                $scope.suggestions = [];
                $scope.suggestionsObj = [];

                //estrapolo l'ultimo tag inserito
                //setLastTag(vm.record.tags);

                //controllo se viene inserito un duplicato
                var tags = vm.record.tags;//.substr(0, $scope.indexLastComma);
                var arrayTag = tags != null ? tags.split(',') : new Array();
                var bExist = false;
                arrayTag.forEach(function (tag) {
                    if (tag.split(' ').join('').toLowerCase() == vm.newWord.split(' ').join('').toLowerCase() && tag.length === vm.newWord.length) {
                        bExist = true;
                    }

                });

                if (bExist) return log("Tag duplicato");

                if (vm.newWord.split(' ').join('').length < 4) return log("Inserisci almeno 4 caratteri.");

                //imposto il nuovo testo nella casella di autocomplete
                setSearchText($scope.selectedIndex);

                vm.record.tags = vm.record.tags + ',';
            }
        };

        //======================================

        $scope.deleteWord = function (index) {
            var arrayTag = vm.record.tags.split(',');
            arrayTag.splice(index, 1);
            vm.record.tags = arrayTag.join(',');
            updateItem();
        };

        function setSearchText(index) {
            if (typeof (vm.newWord) != 'undefined' && typeof ($scope.suggestionsObj) != 'undefined' && index >= 0 && index < $scope.suggestionsObj.length) {
                if (vm.record.tags == null || vm.record.tags.length == 0)
                    vm.record.tags = $scope.suggestionsObj[index].Name; // + ',';
                else
                    vm.record.tags = vm.record.tags + ',' + $scope.suggestionsObj[index].Name; // + ',';

                vm.newWord = '';
            }
            else if (typeof (vm.newWord) != 'undefined' && vm.newWord.length > 3) {
                var newTag = vm.newWord.split(' ').join('');
                if (newTag.length > 3) {
                    if (vm.record.tags == null || vm.record.tags.length == 0)
                        vm.record.tags = newTag;
                    else
                        vm.record.tags = vm.record.tags + ',' + newTag;
                    vm.newWord = '';
                }
            }

        }

        //======================================

    }
})();
